import React from 'react';
import { Award, MapPin, Clock, Heart } from 'lucide-react';

export const About = () => {
  return (
    <section id="about" className="py-24 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-white to-green-50">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                À propos de <span className="text-green-600">David</span>
              </h2>
              <p className="!text-xl text-gray-600">Je m'appelle David, artisan local de confiance à Elven. Passionné par mon métier, j'apporte des solutions rapides et efficaces pour tous vos besoins de la maison et du jardin.

              </p>
            </div>

            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-gray-900">Pourquoi me choisir ?</h3>
              <p className="text-lg text-gray-700 leading-relaxed">
                <strong className="text-green-600">Proximité</strong> : Basé à Elven, j'interviens rapidement chez vous sans frais de déplacement excessifs.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                <strong className="text-green-600">Polyvalence</strong> : Un seul interlocuteur pour tous vos besoins - bricolage, jardinage, informatique.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                <strong className="text-green-600">Clarté</strong> : Pas de mauvaise surprise, nous validons ensemble le besoin avant toute intervention.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                <strong className="text-green-600">Disponibilité</strong> : Ouvert dès 09:00 pour répondre à vos besoins du quotidien.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-1 gap-6 pt-8">
              <div className="text-center p-6 bg-white rounded-xl shadow-md border border-green-100">
                <div className="text-4xl font-bold text-green-600 mb-2">100%</div>
                <div className="text-sm text-gray-600">Satisfaction client</div>
              </div>
            </div>

            {/* Call to Action - Avis Google */}
            <div className="pt-8">
              <a
                href="https://share.google/nr33znE7og5z0bwOS"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-3 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all duration-300">

                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                </svg>
                <span>Partagez votre expérience</span>
              </a>
            </div>
          </div>

          {/* Right Content - Values */}
          <div className="space-y-6">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Award className="w-7 h-7 text-green-600" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Professionnalisme</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Un travail de qualité, réalisé dans les règles de l'art avec le matériel adapté.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-7 h-7 text-green-600" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Proximité</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Artisan local basé à Elven, je connais parfaitement la région et interviens rapidement.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Clock className="w-7 h-7 text-green-600" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Réactivité</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Interventions rapides et planifiées selon vos disponibilités et besoins.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="flex items-start space-x-4">
                <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <Heart className="w-7 h-7 text-green-600" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">À l'écoute</h3>
                  <p className="text-gray-600 leading-relaxed">
                    Une approche humaine et personnalisée pour répondre au mieux à vos attentes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};